import moment from 'moment';
import 'moment/locale/pt-br';

const disableToFutureDates = (currentDate) => moment().isBefore(currentDate);

export default disableToFutureDates;
